// extracted by mini-css-extract-plugin
export var chevron = "_2u-d";
export var disabled = "_2u-b";
export var error = "_2u-c";
export var hideBorder = "_2u-1";
export var icon = "_2u-e";
export var input = "_2u-0";
export var large = "_2u-f";
export var open = "_2u-9";
export var placeholder = "_2u-a";
export var regular = "_2u-5";
export var singleRowInput = "_2u-2";
export var singleSelectInput = "_2u-3 _2u-0";
export var small = "_2u-4";
export var spinnerContainer = "_2u-i";
export var tag = "_2u-7";
export var tagsContainer = "_2u-8";
export var tagsInput = "_2u-6 _2u-0";
export var xSmall = "_2u-g";
export var xxSmall = "_2u-h";